import React, { useState } from 'react';
import { PriceEntry } from './ArtworkPriceTracker';
type PriceEntryFormProps = {
  onAddEntry: (entry: PriceEntry) => void;
};
export function PriceEntryForm({
  onAddEntry
}: PriceEntryFormProps) {
  const [year, setYear] = useState<string>('');
  const [price, setPrice] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!year || !price) {
      setError('Both year and value are required');
      return;
    }
    const yearNum = parseInt(year, 10);
    const priceNum = parseFloat(price);
    if (isNaN(yearNum) || yearNum < 1000 || yearNum > 9999) {
      setError('Please enter a valid year (1000-9999)');
      return;
    }
    if (isNaN(priceNum) || priceNum <= 0) {
      setError('Please enter a valid value greater than zero');
      return;
    }
    onAddEntry({
      id: Date.now().toString(),
      year: yearNum,
      price: priceNum
    });
    setYear('');
    setPrice('');
  };
  return <div data-id="element-50">
      <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-51">Add Value Data</h3>
      <form onSubmit={handleSubmit} data-id="element-52">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" data-id="element-53">
          <div data-id="element-54">
            <label htmlFor="year" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-55">
              Year
            </label>
            <input type="number" id="year" value={year} onChange={e => setYear(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" placeholder="e.g. 2020" min="1000" max="9999" data-id="element-56" />
          </div>
          <div data-id="element-57">
            <label htmlFor="price" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-58">
              Value
            </label>
            <input type="number" id="price" value={price} onChange={e => setPrice(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" placeholder="Enter value" min="0" step="0.01" data-id="element-59" />
            <p className="mt-1 text-sm text-gray-500" data-id="element-60">
              First entry will be set as baseline (100%)
            </p>
          </div>
        </div>
        {error && <div className="mb-4 text-sm text-red-600" data-id="element-61">{error}</div>}
        <button type="submit" className="w-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white py-2 px-4 rounded-md hover:from-indigo-600 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200" data-id="element-62">
          Add Value Data
        </button>
      </form>
    </div>;
}